module.exports = __webpack_public_path__ + "static/media/th.3985e8b3.svg";